import {Container, Singleton} from 'typescript-ioc'
import BaseApi from '@/api/BaseApi'
import {PagingQueryForm} from "biz-ts/src/api/Paging";
import ServerTask from "@/model/ServerTask";

@Singleton
export default abstract class TaskApi {
    abstract paging(form: PagingQueryForm): Promise<Array<ServerTask>>

    abstract cancel(id: number): Promise<Array<ServerTask>>
}

class TaskApiImpl extends BaseApi implements TaskApi {

    protected urlPrefix = 'task'

    paging(form: PagingQueryForm): Promise<Array<ServerTask>> {
        return this.axios.get('paging', {params: form})
    }

    cancel(id: number): Promise<Array<ServerTask>> {
        return this.axios.post('cancel', {id: id})
    }
}

Container.bind(TaskApi).to(TaskApiImpl)
